import { AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios'
import { tokensStorage } from '../helper/storage'
import { logger } from 'app/components'

/**
 * Set "Authorization" header if user authenticated
 */
export function authHttpInterceptor(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const token = tokensStorage.getAccessToken()
  logger.debug('Access token in auth interceptor before sending request: ', token)

  config.headers = config?.headers ?? ({} as AxiosRequestHeaders)
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
}
